import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../lib/useAuth";

export function HqLayout() {
  const { user, logout } = useAuth();
  return (
    <>
      <header className="app">
        <div className="logo">💊</div>
        <div style={{ flex: 1 }}>
          <h1>薬局 情報伝達ハブ</h1>
          <div className="sub">外部情報を取り込み → AIで自動振り分け → HTML資料化 → LINEへ一斉投稿</div>
        </div>
        <div style={{ fontSize: 12, opacity: 0.9 }}>{user?.email}</div>
        <button className="btn ghost sm no-print" onClick={() => logout()} style={{ marginLeft: 12 }}>
          ログアウト
        </button>
      </header>
      <nav className="tabs">
        <NavLink to="/create" className={({ isActive }) => (isActive ? "active" : "")}>
          資料をつくる
        </NavLink>
        <NavLink to="/history" className={({ isActive }) => (isActive ? "active" : "")}>
          資料一覧
        </NavLink>
        <NavLink to="/companies" className={({ isActive }) => (isActive ? "active" : "")}>
          配信先(会社)
        </NavLink>
      </nav>
      <main>
        <Outlet />
      </main>
    </>
  );
}
